import { forwardRef } from 'react';

import { TableCell, TableCellProps } from '@material-ui/core';

import { StateIcon, StateIconProps } from '@spotify/confidence-core-react';

interface StateCellProps
  extends TableCellProps,
    Pick<StateIconProps, 'state' | 'label' | 'error' | 'incomplete'> {}

export const StateCell = forwardRef<HTMLTableCellElement, StateCellProps>(
  ({ state, label, error, incomplete, ...props }, ref) => {
    return (
      <TableCell {...props} ref={ref}>
        <StateIcon
          state={state}
          label={label}
          error={error}
          incomplete={incomplete}
          typographyProps={{ variant: 'body2' }}
          iconProps={{ fontSize: 'small' }}
          // push the icon down a bit to align with the text in the other cells
          style={{ marginTop: 6 }}
        />
      </TableCell>
    );
  },
);
StateCell.displayName = 'StateCell';
